import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "detailsPage" };
const _hoisted_2 = { class: "detailsFields" };
const _hoisted_3 = {
    key: 0,
    class: "fieldError"
};
const _hoisted_4 = { class: "signInField" };
const _hoisted_5 = { class: "signInField" };
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { stringToDate } from '@/utils/helpers';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import MGTextField from './elements/MGTextField.vue';
import DateFieldDrawer from './elements/DateFieldDrawer.vue';
import FieldDrawer from './elements/FieldDrawer.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SignInDetailsPage',
    setup(__props) {
        const router = useRouter();
        useAuth();
        const { addAddress, updateCustomerDetails } = useCustomer();
        const genderOptions = ['Male', 'Female', 'Non-binary', 'Prefer not to say'];
        // The API takes Gender as a single lower-case char
        const genderCodes = {
            'Male': 'm',
            'Female': 'f',
            'Non-binary': 'n',
            'Prefer not to say': 'o',
        };
        const dateOfBirth = ref('');
        const postcode = ref('');
        const gender = ref('');
        const dobError = ref('');
        const saving = ref(false);
        // DateFieldDrawer works in DD/MM/YYYY strings
        function isEighteen(value) {
            const [day, month, year] = value.split('/').map(Number);
            if (!day || !month || !year)
                return false;
            const eighteenth = new Date(year + 18, month - 1, day);
            return !isNaN(eighteenth.getTime()) && eighteenth <= new Date();
        }
        function save() {
            if (!dateOfBirth.value || !postcode.value || !gender.value || saving.value)
                return;
            if (!isEighteen(dateOfBirth.value)) {
                dobError.value = 'You must be 18 or above to use Money Guided.';
                return;
            }
            saving.value = true;
            // The postcode lives on the customer's address, not UpdateRequests — the old flow posts it
            // as person.addresses[] at registration. addAddress fills in country and moveInDateTime.
            // Serial so a failed address save doesn't advance the user on a half-write.
            addAddress({ postCode: postcode.value.trim() }, () => {
                // UpdateRequests ignores nulls, so send only what this page collects. stringToDate
                // keeps DD/MM/YYYY -> YYYY-MM-DD as string work: going via a Date would shift a
                // zoneless date back a day in BST.
                const updateRequest = {
                    dob: stringToDate(dateOfBirth.value) ?? '',
                };
                const code = genderCodes[gender.value];
                if (code)
                    updateRequest.gender = code;
                updateCustomerDetails(updateRequest, () => {
                    saving.value = false;
                    router.push({ path: '/signin/done' });
                });
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "A little about you" }),
                _createElementVNode("div", _hoisted_1, [
                    _cache[9] || (_cache[9] = _createElementVNode("p", { class: "detailsSubtitle" }, "Tell us a bit about yourself so we can make the app more useful to you.", -1)),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["signInField", { hasError: dobError.value }])
                        }, [
                            _cache[5] || (_cache[5] = _createElementVNode("label", null, [
                                _createTextVNode(" Date of birth "),
                                _createElementVNode("span", { class: "fieldHint" }, "You must be 18 or above.")
                            ], -1)),
                            _createVNode(DateFieldDrawer, {
                                modelValue: dateOfBirth.value,
                                "onUpdate:modelValue": [
                                    _cache[0] || (_cache[0] = ($event) => ((dateOfBirth).value = $event)),
                                    _cache[1] || (_cache[1] = ($event) => (dobError.value = ''))
                                ],
                                label: "Date of birth"
                            }, null, 8, ["modelValue"]),
                            (dobError.value)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(dobError.value), 1))
                                : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", _hoisted_4, [
                            _cache[6] || (_cache[6] = _createElementVNode("label", { for: "detailsPostcode" }, "Postcode", -1)),
                            _createVNode(MGTextField, {
                                id: "detailsPostcode",
                                modelValue: postcode.value,
                                "onUpdate:modelValue": [
                                    _cache[2] || (_cache[2] = ($event) => ((postcode).value = $event)),
                                    _cache[3] || (_cache[3] = ($event) => (postcode.value = String($event ?? '').toUpperCase().replace(/[^A-Z0-9 ]/g, '')))
                                ],
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "",
                                "single-line": "",
                                autocomplete: "postal-code",
                                autocapitalize: "characters",
                                "bg-color": "white"
                            }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _cache[7] || (_cache[7] = _createElementVNode("label", null, "Gender", -1)),
                            _createVNode(FieldDrawer, {
                                modelValue: gender.value,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((gender).value = $event)),
                                label: "Gender",
                                placeholder: "Choose",
                                items: genderOptions,
                                showAvatars: false,
                                clearable: false
                            }, null, 8, ["modelValue"])
                        ]),
                        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "detailsPrivacy" }, "We never share your personal details with anyone.", -1)),
                        _createVNode(MGButton, {
                            class: "ctaButton",
                            text: "Continue",
                            arrow: true,
                            fullWidth: true,
                            disabled: !dateOfBirth.value || !postcode.value || !gender.value || saving.value,
                            onClick: save
                        }, null, 8, ["disabled"])
                    ])
                ])
            ], 64));
        };
    }
});
